// Registro das falhas ao montar/enviar as folhas para a pasta `editada`.
//
// Fica na própria compra (`compras/{id}.falhasFoto`) para o suporte responder
// "o que aconteceu com essa compra" sem acesso ao totem. Falha registrada aqui
// é do sistema, nunca do cliente.
import { db } from "@/service/firebase";
import { COLLECTION_COMPRAS } from "@/service/collectionsNames";
import { arrayUnion, doc, setDoc } from "firebase/firestore";

// `tipo`: um dos FALHAS_FOLHA (montagem, conferencia, memoria,
// tempo_esgotado, upload). `indices`: fotos da folha (0-based).
export function montarFalhaFoto(
  { tipo, indices = [], tentativas = null, causa = null, causas = [] },
  agora = new Date()
) {
  return {
    tipo,
    fotos: indices.map((index) => index + 1),
    tentativas,
    causa,
    causas,
    versaoApp: process.env.VUE_APP_VERSION || null,
    em: agora,
  };
}

export function registrarFalhaFoto(compraId, falha) {
  if (!compraId || !falha) return Promise.resolve();
  // Erro síncrono do SDK (ex.: Firestore não inicializado) vira rejeição: quem
  // chama só trata com .catch e o registro nunca pode quebrar o fluxo.
  return Promise.resolve().then(() =>
    setDoc(
      doc(db, COLLECTION_COMPRAS, compraId),
      { falhasFoto: arrayUnion(falha) },
      { merge: true }
    )
  );
}
